import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { IssuesService } from 'src/app/core/service/api/issues.service';
import { LogsService } from 'src/app/core/service/api/logs.service';
import { StakeholdersService } from 'src/app/core/service/api/stakeholders.service';
import { UsersService } from 'src/app/core/service/api/users.service';
import { WorkflowService } from 'src/app/core/service/api/workflow.service';
import { PaginationParams } from 'src/app/core/service/common/pagination-params';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-table-filter-sort',
  templateUrl: './table-filter-sort.component.html',
  styleUrls: ['./table-filter-sort.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableFilterSortComponent {
  stakeholders: any = [];
  issues: any = [];
  users: any = [];
  workflows: any = [];
  logsTitles: any = [];
  urgencyStatuses: any = [
    { id: 1, name: "negligible" },
    { id: 2, name: "low" },
    { id: 3, name: "middle" },
    { id: 4, name: "high" },
    { id: 5, name: "very-high" },
    { id: 6, name: "catastrophic" }
  ];
  reqStatuses: any = [
    { id: 1, name: "initial" },
    { id: 2, name: "evaluation" },
    { id: 3, name: "gehonoreerd" },
    { id: 4, name: "afgewezen" },
    { id: 5, name: "expired" },
    { id: 6, name: "next_phase" }
  ];
  permitStatus: any = [
    { id: 1, name: "open" },
    { id: 2, name: "in_progress" },
    { id: 3, name: "rejected" },
    { id: 4, name: "approved" }
  ];
  complaintStatus: any = [
    { id: 1, name: "open", status: 'open' },
    { id: 2, name: "pending", status: 'pending' },
    { id: 3, name: "closed", status: 'closed' }
  ];
  contact_moment_types: any = [
    { id: 1, name: "email" },
    { id: 2, name: "phone" },
    { id: 3, name: "meeting" }
  ];
  contact_moment_sources: any = [
    { id: 1, name: "IMAP", icon: "envelope.svg" },
    { id: 2, name: "Outlook", icon: "outlook.svg" }
  ];
  selectedLegalBasis: any = [];
  selectedUsers: any = [];
  selectedLogsTitle: any = [];
  selectedStrategie: any = [];
  strategieFilters: any = [];
  selectedWorkflows: any = [];
  selectedUrgencyStatus: any = [];
  selectedReqStatus: any = [];
  selectedComplaintStatus: any = [];
  selectedPermitStatus: any = [];
  selectedContactmomentType: any = [];
  selectedContactmomentSource: any = [];
  selectedActionItems: any = [];
  selectedComplaintee: any = [];
  @Input() moduleName: string = '';
  @Input() selectedOptions: any;
  @Input() isFilterActive: boolean = true;
  @Input() appliedSorting : any = null;
  @Input() enabledFilters : string[] = [];
  @Input() enabledSorts : string[] = [];
  @Input() legalBasis : any[] = [];
  @Input() actionItems : any[] = [];
  @Input() complaintee : any[] = [];
  @Input() public paginator: PaginationParams;
// eslint-disable-next-line @angular-eslint/no-output-on-prefix
@Output() public onApply: EventEmitter<any> = new EventEmitter();
// eslint-disable-next-line @angular-eslint/no-output-on-prefix
@Output() public onFilterChange: EventEmitter<any> = new EventEmitter();
  isFilterDropdownOpen: boolean = false;
  isSortDropdownOpen: boolean = false;
  selectedSortOption: any = "stakeholders.name";
  filteredStakeholders: any = [];
  filteredIssues: any = [];
  private defaultAnalysisSort: any = {};
  originalSelectedFilters: any = {'themeissues.name': [], 'stakeholdertypes.name': [], 'theme_requirements.name': [], 'permitstypes.name': [], 'permitsclusters.name': [], 'permitsrequesters.name': [], 'permitsvalidities.name': [], 'complaintthemes.name': []};
  selectedFilters: any = {};
  key = 'project.stakeholder_strategy.is_new';
  @ViewChild('filterDropdownRef') filterDropdownRef!: ElementRef;
  @ViewChild('sortDropdownRef') sortDropdownRef!: ElementRef;

  constructor(private _StakeholdersService: StakeholdersService, private _workflowService: WorkflowService, private _IssuesService: IssuesService, private _usersService: UsersService, public globals: Globals, private _LogsService: LogsService){
    this._StakeholdersService.getStakeholdersRelations().subscribe((res)=>{
      this.stakeholders = res;
    })
    this._IssuesService.getUnfilteredIssuesRelation().subscribe((res)=>{
      this.issues = res;
    })
    this._usersService.getUsers().subscribe(
      (response: any) => {
        this.users = response.data;
      }
    );
    this._workflowService.getAllWorksflows().subscribe( res => this.workflows = res);
    this._LogsService.getLogsRelations().subscribe( (res) => {
      this.logsTitles=res;
    });
    this.strategieFilters = this.getStrategieFilters();
  }

  private getStrategieFilters() {
    if (this.globals.projectConfigs[this.key]) {
      return [
        { id: 1, name: "Reactief" },
        { id: 2, name: "Informeren" },
        { id: 3, name: "Adviseren" },
        { id: 4, name: "Raadplegen" },
        { id: 5, name: "Coproduceren" },
        { id: 6, name: "Meebeslissen" },
        { id: 7, name: "Ongecategoriseerd" },
      ];
    }

    return [
      { id: 1, name: "Informeren" },
      { id: 2, name: "Monitoren" },
      { id: 3, name: "Ongecategoriseerd" },
      { id: 4, name: "Samenwerken" },
      { id: 5, name: "Tevreden houden" },
    ];
  }

  ngOnChanges() {
    if (this.paginator && this.paginator._analysisSort && Object.keys(this.defaultAnalysisSort).length === 0) {
      this.defaultAnalysisSort = { ...this.paginator._analysisSort };
    }
    if (this.appliedSorting === null && this.selectedSortOption === 'theme_types.name') {
      this.selectedSortOption = "stakeholders.name";
    }
    if (this.selectedOptions?.name === 'issue' && this.selectedOptions?.selectedStakeholder?.id === this.filteredIssues[0]?.id && this.isFilterActive){
      this.filteredStakeholders = [...this.selectedOptions.selectedStakeholder.stakeholders];
      this.filteredIssues = this.issues.filter(item => item.id === this.selectedOptions.selectedStakeholder.id);
      this.applyDefaultFilters()
    }
    if (this.selectedOptions?.name === 'stakeholder' && this.selectedOptions?.selectedIssue?.id === this.filteredStakeholders[0]?.id && this.isFilterActive){
      this.filteredIssues = [...this.selectedOptions.selectedIssue.issues];
      this.filteredStakeholders = this.stakeholders.filter(item => item.id === this.selectedOptions.selectedIssue.id);
      this.applyDefaultFilters()
    }
    if (this.selectedOptions?.name === 'issue' && this.selectedOptions?.selectedStakeholder?.id !== this.filteredIssues[0]?.id) {
      this.filteredStakeholders = this.selectedOptions.selectedStakeholder.stakeholders;
      this.filteredIssues = this.issues.filter(item => item.id === this.selectedOptions.selectedStakeholder.id);
      this.applyDefaultFilters()
    } else if (this.selectedOptions?.name === 'stakeholder' && this.selectedOptions?.selectedIssue?.id !== this.filteredStakeholders[0]?.id) {
      this.filteredIssues = this.selectedOptions.selectedIssue.issues;
      this.filteredStakeholders = this.stakeholders.filter(item => item.id === this.selectedOptions.selectedIssue.id);
      this.applyDefaultFilters()
    }
    //By default remove filter applied
    // if (this.selectedOptions === null && !this.isFilterActive ) {
    //   this.removeFilters();
    // }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInsideFilter = this.filterDropdownRef?.nativeElement.contains(target);
    const clickedInsideSort = this.sortDropdownRef?.nativeElement.contains(target);
    const isFilterButton = target.closest('.filter-toggle-btn');
    const isSortButton = target.closest('.sort-toggle-btn');
    if (!clickedInsideFilter && !isFilterButton) {
      this.isFilterDropdownOpen = false;
    }
    if (!clickedInsideSort && !isSortButton) {
      this.isSortDropdownOpen = false;
    }
  }

  removeSorts(){
    this.selectedSortOption = "stakeholders.name";
    this.selectedOptions = null;
    this.paginator._analysisSort = { ...this.defaultAnalysisSort };
    const analysisSort = this.paginator._analysisSort;
    for (const key in analysisSort) {
      if (key.includes("score")) {
        analysisSort[key] = 'desc';
        continue;
      }
      analysisSort[key] = 'asc';
    }
    this.onApply.emit({isSort: true});
    this.isSortDropdownOpen = false;
  }

  removeFilters(){
    this.selectedOptions = null;
    this.isFilterActive = false;
    this.filteredStakeholders = [];
    this.filteredIssues = [];
    this.selectedUsers = [];
    this.selectedStrategie = [];
    this.selectedWorkflows = [];
    this.selectedUrgencyStatus = [];
    this.selectedLogsTitle = [];
    this.selectedReqStatus = [];
    this.selectedPermitStatus = [];
    this.selectedComplaintStatus = [];
    this.selectedContactmomentType = [];
    this.selectedContactmomentSource = [];
    this.selectedLegalBasis = [];
    this.selectedActionItems = [];
    this.selectedComplaintee = [];
    this.originalSelectedFilters = {'themeissues.name': [], 'stakeholdertypes.name': [], 'theme_requirements.name': [], 'permitstypes.name': [], 'permitsclusters.name': [], 'permitsrequesters.name': [], 'permitsvalidities.name': [], 'complaintthemes.name': []};
    this.selectedFilters = {};
    this.paginator._filters = {};
    this.onApply.emit({remove: true});
    this.isFilterDropdownOpen = false;
  }

  changeAnalysisSort(direction='asc') {
    if (this.selectedSortOption === 'theme_types.name') {
      this.paginator._analysisSort['stakeholders.name']=direction;
      this.paginator._analysisSort['issues.name']=direction;
      this.paginator._analysisSort['issues.themeissues.name']=direction;
      this.paginator._analysisSort['stakeholders.stakeholdertypes.name']=direction;
      this.onApply.emit({sortOption: this.selectedSortOption});
      return;
    }
    direction = (this.selectedSortOption === 'issues.issues_score' || this.selectedSortOption === 'stakeholders.score') ? 'desc':'asc';
    const analysisSort = this.paginator._analysisSort;
    for (const key in analysisSort) {
      if (key !== this.selectedSortOption) {
        delete analysisSort[key];
      }
    }
    analysisSort[this.selectedSortOption] = direction;
    this.onApply.emit({isSort: true});
  }

  applyDefaultFilters(){
    this.selectedFilters['stakeholdertypes.name'] = [];
    this.selectedFilters['themeissues.name'] = [];
    this.originalSelectedFilters['stakeholdertypes.name'] = [];
    this.originalSelectedFilters['themeissues.name'] = [];
    this.selectedIssueStakeholderTheme(this.filteredIssues, 'issues.id', true);
    this.selectedIssueStakeholderTheme(this.filteredStakeholders, 'stakeholders.id', false);
  }

  selectedIssueStakeholderTheme(data: any, name: string, apply = false) {
    let filterIdsNames;
    if(name=='contact_moment_type') {
      data = this.combineCMData();
    };
    this.originalSelectedFilters[name] = data;
    if (this.areAllFiltersEmpty()) {
      this.removeFilters()
      return;
    }
    this.isFilterActive = true;
    if (this.shouldUseNameFilter(name)) {
      filterIdsNames = data.map(f => f.name);
      if (name === 'status' && filterIdsNames.includes('in_progress')) {
        // Avoid duplicates
        if (!filterIdsNames.includes('pending')) {
          filterIdsNames.push('pending');
        }
      }
    } else if(name!=='status' && name!=='title'){
      filterIdsNames= data.map(f => f.id);
    } else if (name==='status') {
      filterIdsNames= data.map(f => f.status);
    } else {
      filterIdsNames= data.map(f => f.title);
    }
    if (name!=='matrices.strategie'&&name!=='') {
      this.selectedFilters[name] = filterIdsNames;
    } else {
      this.selectedFilters.filter_field = filterIdsNames;
    }
    this.paginator._filters = { ...this.selectedFilters };
    if (this.selectedOptions?.name && (this.selectedOptions?.selectedStakeholder?.stakeholders || this.selectedOptions?.selectedIssue?.issues) && !apply) {
      this.onFilterChange.emit({
        name: this.selectedOptions.name,
        filteredStakeholders: this.filteredStakeholders,
        filteredIssues: this.filteredIssues,
        stakeholdersTheme: this.originalSelectedFilters['stakeholdertypes.name'],
        issuesTheme: this.originalSelectedFilters['themeissues.name']
      });
    }
    if (!apply && (name === 'themeissues.name' || name === 'stakeholdertypes.name') && this.moduleName==='analysis')
      this.onApply.emit({ activeFilter: name, removeappliedFilterName: this.originalSelectedFilters[name].length > 0 ? false: true });
    else if(!apply)
      this.onApply.emit();
  }

  onRemove(event: MouseEvent, type = 'stkeholder') {
    event.stopPropagation();
    if (type === 'stkeholder')
      this.removeFilters();
    else
      this.removeSorts();
  }

  combineCMData(){
    return [...this.selectedContactmomentSource, ...this.selectedContactmomentType];
  }

  areAllFiltersEmpty(): boolean {
    return !this.selectedComplaintee?.length
        && !this.filteredIssues?.length
        && !this.filteredStakeholders?.length
        && !this.originalSelectedFilters['themeissues.name']?.length
        && !this.originalSelectedFilters['stakeholdertypes.name']?.length
        && !this.selectedUsers?.length
        && !this.selectedStrategie?.length
        && !this.selectedWorkflows?.length
        && !this.selectedUrgencyStatus?.length
        && !this.selectedReqStatus?.length
        && !this.originalSelectedFilters['theme_requirements.name']?.length
        && !this.selectedContactmomentType?.length
        && !this.selectedContactmomentSource?.length
        && !this.originalSelectedFilters['permitstypes.name']?.length
        && !this.originalSelectedFilters['permitsclusters.name']?.length
        && !this.originalSelectedFilters['permitsrequesters.name']?.length
        && !this.originalSelectedFilters['permitsvalidities.name']?.length
        && !this.originalSelectedFilters['complaintthemes.name']?.length
        && !this.selectedPermitStatus?.length
        && !this.selectedComplaintStatus?.length
        && !this.selectedLogsTitle?.length
        && !this.selectedLegalBasis?.length
        && !this.selectedActionItems?.length;
  }
  shouldUseNameFilter(name: string): boolean {
    return name === '' || name === 'themeissues.name'
    || name === 'stakeholdertypes.name' || name === 'users.name'
    || name === 'matrices.strategie' || (name === 'stakeholders.name' && (this.moduleName !== 'analysis'))
    || name === 'workflows.name' || name === 'urgency'
    || name === 'status' || name === 'theme_requirements.name'
    || name === 'contact_moment_type' || name === 'permitstypes.name'
    || name === 'permitsclusters.name' || name === 'permitsrequesters.name'
    || name === 'permitsvalidities.name' || name === 'complaintthemes.name'
    || name === 'legal_basis' || name === 'complaints'
    || (name !== 'status' && name !== 'title');
  }
}
